import { format, formatDistanceToNow } from 'date-fns';

export function formatRelativeTime(value?: string): string {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return formatDistanceToNow(d, { addSuffix: true });
}

/** e.g. "07:07 PM" */
export function formatTimeOnly(value?: string): string {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return format(d, 'hh:mm a');
}
